import React from "react";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from "@material-ui/icons/Error";
import withStyles from "components/with-styles";
import { getMultilangMessage } from "utils/multilang";
import styles from "./styles/authentication-error.css.js";

const AuthenticationError = ({ classes }) => (
  <div className={classes.root}>
    <ErrorIcon color="error" fontSize="large" />
    <Typography variant="body1">{getMultilangMessage("authenticationError")}</Typography>
  </div>
);

export default withStyles(styles)(AuthenticationError);
